// src/components/Members.jsx
import React, { useEffect, useState, useMemo } from "react";
import { adminGet, adminPost,adminDelete, adminPut } from "../../../Services";
import { AgGridReact } from "ag-grid-react";
import {
  ClientSideRowModelModule,
  GridStateModule,
  RowSelectionModule,
  ModuleRegistry,
} from "ag-grid-community";
import {
  Container,
  Spinner,
  Form,
  Modal,
  Row,
  Col,
  Card,
  Button,
  Badge,
} from "react-bootstrap";
import { toast } from "react-toastify";
import ApplyDesignationModal from "./applyDesignationModal";
import { formatDateTime } from "../../../utils/helpers";

ModuleRegistry.registerModules([
  RowSelectionModule,
  GridStateModule,
  ClientSideRowModelModule,
]);

const EarlyMember = () => {
  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [gridApi, setGridApi] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedData, setSelectedData] = useState({});
  
  const [search, setSearch] = useState("");
  
  const [showImageModal, setShowImageModal] = useState(false);
  const [activeImage, setActiveImage] = useState(null);
  const [editableData, setEditableData] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const [updateDone, setUpdateDone] = useState(false);

//   Change inside your action cell renderer:

// onClick={() => {
//   setSelectedData(params.data);
//   setEditableData({ ...params.data });
//   setShowModal(true);
//   setIsEditing(false);
//   setUpdateDone(false);
// }}


  const handleImageClick = (imgUrl) => {
    setActiveImage(imgUrl);
    setShowImageModal(true);
  };

  const fetchMembers = () => {
    adminGet("/api/members/early/getAll")
      .then((res) => {
        setRowData(res.data);
        console.log(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // const handleUpdate = () =>{
  //   adminPut(`/api/members/early/update/${selectedData.id}`, editableData)
  //     .then((res) => {
  //       toast.success("Member Data Updated successfully!");
  //       fetchMembers();
  //       // setShowModal(false);
  //       // setIsEditing(false);
  //       // setUpdateDone(true);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       toast.error(err.response.data.error);
  //     });
  // }


  const handleApprove = () => {
    setLoading(true);
    adminGet(`/api/members/early/verify/${selectedData.id}`)
      .then((res) => {
        fetchMembers();
        toast.success("Member approved successfully!");
        setSelectedData((prev) => ({
          ...prev,
          approved: true,
        }));
      })
      .catch((err) => {
        console.log(err);
        toast.error(err.response.data.error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

 
  useEffect(() => {
    fetchMembers();
  }, []);

  const columnDefs = [
    { headerName: "Reg ID", field: "registration_id", sortable: true },
    { headerName: "Name", field: "name", sortable: true },
    { headerName: "State", field: "state", sortable: true },
    { headerName: "District", field: "district", sortable: true },
    { headerName: "Block", field: "block", sortable: true },
    { headerName: "Approved", field: "approved", sortable: true },
    {
      headerName: "Member Since",
      field: "member_since",
      sortable: true,
      valueFormatter: (params) => formatDateTime(params.value),
    },
    {
      headerName: "Created At",
      field: "createdAt",
      sortable: true,
      valueFormatter: (params) => formatDateTime(params.value),
    },
    {
      headerName: "Updated At",
      field: "updatedAt",
      sortable: true,
      valueFormatter: (params) => formatDateTime(params.value),
    },
    {
      headerName: "Actions",
      field: "actions",
      cellRenderer: (params) => (
        <div
          className="text-primary"
          style={{ cursor: "pointer", textAlign: "center" }}
          onClick={() => {
            setSelectedData(params.data);
            setShowModal(true);
          }}
        >
          <i className="bi bi-eye" style={{ fontSize: "1.5rem" }}></i>
        </div>
      ),
      pinned: "right",
      width: 80,
    },
    {
      headerName: "Delete",
      field: "delete",
      cellRenderer: (params) => (
        <div
          className="text-danger"
          style={{ cursor: "pointer", textAlign: "center" }}
          onClick={async () => {
            if (window.confirm("Are you sure to delete this member?")) {
              try {
                await adminDelete(
                  `/api/members/early/delete/${params.data.id}`,
                  {},
                  "delete"
                );
                toast.success("Deleted successfully");
                fetchMembers();
              } catch (err) {
                toast.error("Delete failed");
              }
            }
          }}
        >
          <i className="bi bi-trash" style={{ fontSize: "1.3rem" }}></i>
        </div>
      ),
      pinned: "right",
      width: 80,
    },
  ];

  const onGridReady = (params) => {
    setGridApi(params.api);
  };


  return (
    <div className="p-2 pt-0">
      <div className="mb-2 d-flex align-items-center justify-content-between ">
        <h3 className="fw-medium" style={{ color: "#1a5276" }}>
          Early Members List
        </h3>

        <Form.Control
          type="text"
          placeholder="Search members..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ width: "250px", marginRight: 10 }}
        />
      </div>

      <div className="position-relative">
        {loading && (
          <div className="d-flex justify-content-center align-items-center position-absolute top-0 start-0 w-100 h-100 bg-white bg-opacity-75">
            <Spinner animation="border" variant="primary" />
          </div>
        )}

        <div
          className="ag-theme-alpine"
          style={{ height: "80vh", width: "100%" }}
        >
          <AgGridReact
            columnDefs={columnDefs}
            rowModelType="clientSide"
            rowData={rowData.filter((row) =>
              [row.name, row.registration_id, row.state, row.district].some(
                (field) =>
                  field?.toString().toLowerCase().includes(search.toLowerCase())
              )
            )}
            onGridReady={onGridReady}
            overlayLoadingTemplate='<span class="ag-overlay-loading-center">Loading...</span>'
            overlayNoRowsTemplate='<span class="ag-overlay-no-rows-center">No records found.</span>'
          />
        </div>
      </div>

      {/*Modal*/}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
        className="application-review-modal"
      >
        <Modal.Header closeButton className="modal-header-custom">
          <Modal.Title>
            <i className="bi bi-clipboard-check me-2"></i>
            "Review Application"
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <Row className="g-0">
            <Col md={8} className="p-4">
              <div className="section-title fs-5">
                <i className="bi bi-person-badge me-2"></i>
                Personal Information
              </div>

              <Row>
                <Col sm={6}>
                  <div className="data-field">
                    <label>Registration No</label>
                    <p>{selectedData.registration_id || "Not provided"}</p>
                  </div>
                </Col>
              </Row>

              {/* <div className="data-field d-flex align-items-center">
                <label>Full Name</label>
                {isEditing ? (
                  <Form.Control
                    size="sm"
                    type="text"
                    value={editableData.name || ""}
                    onChange={(e) =>
                      setEditableData({ ...editableData, name: e.target.value })
                    }
                  />
                ) : (
                  <p className="mb-0">{editableData.name || "Not provided"}</p>
                )}
                <i
                  className="bi bi-pencil ms-2"
                  style={{ cursor: "pointer" }}
                  onClick={() => setIsEditing(true)}
                ></i>
              </div> */}
              <Row>
                <Col sm={6}>
                  <div className="data-field">
                    <label>Full Name</label>
                    <p>{selectedData.name || "Not provided"}</p>
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="data-field">
                    <label>Date of Birth</label>
                    <p>{selectedData.dob || "Not provided"}</p>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col sm={6}>
                  <div className="data-field">
                    <label>Profession</label>
                    <p>{selectedData.profession || "Not provided"}</p>
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="data-field">
                    <label>Mobile Number</label>
                    <p>{selectedData.mobile_no || "Not provided"}</p>
                  </div>
                </Col>
              </Row>

              <div className="data-field">
                <label>Email Address</label>
                <p>{selectedData.email || "Not provided"}</p>
              </div>

              <div className="section-title mt-4 fs-5">
                <i className="bi bi-geo-alt me-2"></i>
                Address Details
              </div>

              <Row>
                <Col sm={6}>
                  <div className="data-field">
                    <label>State</label>
                    <p>{selectedData.state || "Not provided"}</p>
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="data-field">
                    <label>District</label>
                    <p>{selectedData.district || "Not provided"}</p>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col sm={6}>
                  <div className="data-field">
                    <label>Block</label>
                    <p>{selectedData.block || "Not provided"}</p>
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="data-field">
                    <label>PIN Code</label>
                    <p>{selectedData.pin || "Not provided"}</p>
                  </div>
                </Col>
              </Row>

              <div className="section-title mt-4 fs-5">
                <i className="bi bi-card-checklist me-2"></i>
                Identification & Documents
              </div>

              <Row>
                <Col sm={6}>
                  <div className="data-field">
                    <label>Aadhaar Number</label>
                    <p>{selectedData.aadhaar_no || "Not provided"}</p>
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="data-field">
                    <label>Vehicle Number</label>
                    <p>{selectedData.vehicle_no || "Not provided"}</p>
                  </div>
                </Col>
              </Row>
            </Col>

            <Col md={4} className="documents-sidebar">
              <div className="p-3">
                <h6 className="text-center mb-3">
                  <i className="bi bi-images me-2"></i>
                  Uploaded Documents
                </h6>

                {selectedData.photo_url && (
                  <Card className="mb-3 document-card">
                    <Card.Header className="text-center">
                      Profile Photo
                    </Card.Header>
                    <Card.Body className="text-center p-2">
                      <img
                        src={`${selectedData.photo_url}`}
                        alt="Profile"
                        className="uploaded-image"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          handleImageClick(`${selectedData.photo_url}`)
                        }
                      />
                    </Card.Body>
                  </Card>
                )}

                {selectedData.aadhaar_url && (
                  <Card className="document-card mb-3">
                    <Card.Header className="text-center">
                      Aadhaar Card
                    </Card.Header>
                    <Card.Body className="text-center p-2">
                      <img
                        src={`${selectedData.aadhaar_url}`}
                        alt="Aadhaar Card"
                        className="uploaded-image"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          handleImageClick(`${selectedData.aadhaar_url}`)
                        }
                      />
                    </Card.Body>
                  </Card>
                )}

                {selectedData.idCard_url && (
                  <Card className="document-card">
                    <Card.Header className="text-center">Id Card</Card.Header>
                    <Card.Body className="text-center p-2">
                      <img
                        src={`${selectedData.idCard_url}`}
                        alt="Id Card"
                        className="uploaded-image"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          handleImageClick(`${selectedData.idCard_url}`)
                        }
                      />
                    </Card.Body>
                  </Card>
                )}

              </div>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="modal-footer-custom">
          <Button
            variant="outline-secondary"
            onClick={() => setShowModal(false)}
          >
            <i className="bi bi-arrow-left me-2"></i>
            Close
          </Button>

          {/* <Button
            variant="success"
            onClick={handleUpdate}
            className="d-flex align-items-center"
          >
            <i className="bi bi-credit-card me-2"></i>
            Update
          </Button> */}

          <Button
            variant="success"
            onClick={handleApprove}
            className="d-flex align-items-center"
            disabled={selectedData.addedToMember}
          >
            <i className="bi bi-credit-card me-2"></i>
            {!selectedData.addedToMember ? "Approve":"Approved"}
          </Button>

          {/* <Button
            variant="success"
            onClick={async () => {
              if (!updateDone) {
                // 🔹 Call update API
                try {
                  await adminPost(
                    `/api/members/early/update/${selectedData.id}`,
                    editableData,
                    "put"
                  );
                  toast.success("Update successful");
                  setUpdateDone(true);
                  setIsEditing(false);
                  fetchMembers();
                } catch (err) {
                  toast.error("Update failed");
                }
              } else {
                // 🔹 Call approve API
                try {
                  await adminGet(
                    `/api/members/early/verify/${selectedData.id}`
                  );
                  toast.success("Member approved");
                  setShowModal(false);
                  fetchMembers();
                } catch (err) {
                  toast.error("Approval failed");
                }
              }
            }}
            className="d-flex align-items-center"
          >
            <i className="bi bi-credit-card me-2"></i>
            {updateDone ? "Approve" : "Update"}
          </Button> */}
        </Modal.Footer>
      </Modal>

      {/* Image Preview Modal */}
      <Modal
        show={showImageModal}
        onHide={() => setShowImageModal(false)}
        size="lg"
        centered
      >
        <Modal.Body className="text-center">
          <img
            src={activeImage}
            alt="Preview"
            style={{ maxWidth: "100%", maxHeight: "80vh" }}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default EarlyMember;
